import type { AgentType } from '../types';

export type KnownAgentType =
  | `${AgentType}`
  | 'stage_prospect_intake'
  | 'stage_first_contact'
  | 'stage_qualification_deep'
  | 'stage_proposal_prep'
  | 'stage_won_onboarding'
  | 'stage_lost_analysis'
  | 'linkedin_enrichment'
  | 'instagram_enrichment'
  | 'instagram_company_enrichment'
  | 'company_enrichment'
  | 'voice_call';

const AGENT_TYPE_LABEL_KEYS: Record<KnownAgentType, string> = {
  lead_qualification: 'leadQualification',
  lead_enrichment: 'leadEnrichment',
  follow_up_scheduler: 'followUpScheduler',
  sentiment_analysis: 'sentimentAnalysis',
  prompt_enricher: 'promptEnricher',
  linkedin_company_research: 'linkedinCompanyResearch',
  browser_company_research: 'browserCompanyResearch',
  flowsellai_company_research: 'flowsellaiCompanyResearch',
  instagram_company_research: 'instagramCompanyResearch',
  orchestrator: 'chatOrchestrator',
  stage_prospect_intake: 'stageProspectIntake',
  stage_first_contact: 'stageFirstContact',
  stage_qualification_deep: 'stageQualificationDeep',
  stage_proposal_prep: 'stageProposalPrep',
  stage_won_onboarding: 'stageWonOnboarding',
  stage_lost_analysis: 'stageLostAnalysis',
  linkedin_enrichment: 'linkedinEnrichment',
  instagram_enrichment: 'instagramEnrichment',
  instagram_company_enrichment: 'instagramCompanyEnrichment',
  company_enrichment: 'companyEnrichment',
  voice_call: 'voiceCall',
};

export const KNOWN_AGENT_TYPES = Object.keys(AGENT_TYPE_LABEL_KEYS) as KnownAgentType[];

function isKnownAgentType(agentType: string): agentType is KnownAgentType {
  return Object.hasOwn(AGENT_TYPE_LABEL_KEYS, agentType);
}

export function agentTypeLabelKey(agentType: string): string {
  const leaf = isKnownAgentType(agentType) ? AGENT_TYPE_LABEL_KEYS[agentType] : 'generic';
  return `common.agentTypes.${leaf}`;
}
